import { useEffect, useRef } from 'react';

const KONAMI = [
  'ArrowUp', 'ArrowUp',
  'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight',
  'ArrowLeft', 'ArrowRight',
  'b', 'a',
];

export default function useKonamiCode(callback) {
  const index = useRef(0);

  useEffect(() => {
    function onKeyDown(e) {
      const expected = KONAMI[index.current];
      if (e.key === expected || e.key.toLowerCase() === expected) {
        index.current++;
        if (index.current === KONAMI.length) {
          index.current = 0;
          callback();
        }
      } else {
        index.current = 0;
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [callback]);
}
